import styled from "@emotion/styled"
import { Container, Typography } from "@mui/material"
import CustomLink from "../custom-link/custom-link.component"
import CustomImage from "../custom-image/custom-image.component"

export const Wrapper = styled.footer`
  color: white;
  padding: 2em 0 3em 0;
  background-color: #323a46;
  position: relative;
  ${({ theme }) => theme.breakpoints.down("sm")} {
    .MuiContainer-root {
      padding-right: 24px;
      padding-left: 24px;
    }
  }
`
export const FooterBanner = styled(CustomImage)`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  height: 100%;

  ${({ theme }) => theme.breakpoints.down("lg")} {
    img {
      object-fit: cover !important;
    }
  }
`

export const CustomContainer = styled(Container)`
  position: relative;
  z-index: 3;
`

export const Subtitle = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: ${({ theme }) => theme.typography.pxToRem(28)};
  line-height: 36px;
`

export const Content = styled.div`
  p {
    font-style: normal;
    font-weight: 400;
    font-size: ${({ theme }) => theme.typography.pxToRem(16)};
    line-height: 24px;
  }
`

export const Link = styled(CustomLink)`
  font-style: normal;
  font-weight: 400;
  font-size: ${({ theme }) => theme.typography.pxToRem(16)};
  line-height: 24px;
  border-bottom: 2px solid transparent;
  transition: 0.3s all ease;
  &:hover {
    border-bottom: 2px solid white;
  }
`

export const ExternalLink = styled.a`
  font-style: normal;
  text-decoration: none;
  font-weight: 400;
  font-size: ${({ theme }) => theme.typography.pxToRem(16)};
  line-height: 24px;
  color: white;
  border-bottom: 2px solid transparent;
  transition: 0.3s all ease;
  &:hover {
    border-bottom: 2px solid white;
  }
`

export const SocialWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2em;
`

export const FormWrapper = styled.div`
  margin: 1rem 0;
`

export const Mail = styled(Typography)`
  margin: 2rem 0;
`

export const TermsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  font-style: normal;
  font-weight: 400;
  font-size: ${({ theme }) => theme.typography.pxToRem(16)};
  line-height: 21px;
  margin-top: 2rem;

  ${({ theme }) => theme.breakpoints.up("md")} {
    max-width: 250px;
  }
  &.treez {
    max-width: unset;
    justify-content: center;
  }
`

export const SuccessMessage = styled(Typography)`
  font-size: ${({ theme }) => theme.typography.pxToRem(18)};
`
